/**
 * Branded (nominal) types. Prevents mixing up IDs of different entities
 * at compile time — e.g. you can't pass a `MerchantId` where a `PaymentId`
 * is expected, even though both are strings at runtime.
 */
declare const __brand: unique symbol;

export type Brand<T, B extends string> = T & { readonly [__brand]: B };

export const brand = <T, B extends string>(value: T): Brand<T, B> => value as Brand<T, B>;
export const unbrand = <T, B extends string>(value: Brand<T, B>): T => value as T;

// Common ID brands. Add more in the feature that owns the entity.
export type MerchantId = Brand<string, 'MerchantId'>;
export type PaymentIntentId = Brand<string, 'PaymentIntentId'>;
export type TerminalId = Brand<string, 'TerminalId'>;
export type SettlementId = Brand<string, 'SettlementId'>;
export type WebhookEndpointId = Brand<string, 'WebhookEndpointId'>;
export type UserId = Brand<string, 'UserId'>;
